<template>
   <div>
      <i18n-t :keypath="`${path}.text`" tag="div" scope="global">
         <template v-if="linkHref && $te(`${path}.link`)" v-slot:link>
            <a
               :href="linkHref"
               target="_blank"
               class="whitespace-no-wrap relative inline-block underline"
               rel="nofollow noopener noreferrer"
            >
               {{ $t(`${path}.link`) }}
            </a>
         </template>

         <template v-slot:new_line><br class="mb-2" /></template>

         <template v-for="i in numOfTextBold" :key="`instruction-slot-${i}`" v-slot:[`text_bold_${i}`]>
            <span class="text-bolder">{{ $t(`${path}.text_bold_${i}`) }}</span>
         </template>
      </i18n-t>
      <img v-if="imgSrc" class="mt-4 hidden md:block" :src="imgSrc" />
   </div>
</template>

<script setup lang="ts">
import { useI18n } from "@/vue-i18n/vue-i18n";
const { te: $te } = useI18n();
interface InstructionData {
   path: string;
   linkHref?: string;
   numOfTextBold?: number;
   imgSrc?: string;
}

defineProps<InstructionData>();
</script>
